const SORT_BY = {
  NEWEST: 'newest',
  CREATION_DATE: 'creation_date',
  ALPHABET: 'alphabet',
}

const ROLE = {
  ADMIN: 'ADMIN', // Quản trị viên
  HEADMASTER: 'HEADMASTER', // Hiệu trưởng
  VICE_HEADMASTER: 'VICEHEADMASTER', // Hiệu phó
  TEACHER: 'TEACHER', // Giáo viên
  STUDENT: 'STUDENT', // Học sinh / Phụ huynh
}

const COMMON = {
  SORT_BY,
  ROLE,
}

export default COMMON
